<template>
	<!-- 抽盒商品 -->
	<div class="rootDiv">
		<div class="retrieve">
			<div class="searchDiv flex flex-jb">
				<div>
					<el-input @keydown.enter.native="submitSearch" @clear="submitSearch" clearable class="w-450" placeholder="请输入"
						v-model="retrieveForm.searchValue">
						<el-button slot="append" type="primary" icon="el-icon-search" @click="submitSearch"></el-button>
					</el-input>
				</div>
				<div class="flex flex-ac">
					<div class="fs-16 fc-6b9eff pointer" @click="addList">
						<i class="el-icon-circle-plus-outline mr-10 fs-18"></i>新增
					</div>
				</div>
			</div>
			<div class="retrieveDiv flex flex-ac">
				<div class="mr-30 flex flex-ac">
					<span class="fs-16 flex1 mr-20">轮播图名称：</span>
					<el-input class="w-250" v-model="retrieveForm.slideName" clearable></el-input>
				</div>
				<div class="mr-30 flex flex-ac">
					<span class="fs-16 flex1 mr-20">系列名称：</span>
					<el-input class="w-250" v-model="retrieveForm.seriesName" clearable></el-input>
				</div>
				<div class="mr-30 flex flex-ac">
					<span class="fs-16 flex1 mr-20">类型：</span>
					<el-select class="w-250" v-model="retrieveForm.boxType" clearable placeholder="请选择">
						<el-option v-for="item in boxTypes" :key="item.value" :label="item.key" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div>
					<el-button type="primary" @click="submitSearch">查询</el-button>
				</div>
			</div>
		</div>
		<TableHeightFull class="tableDiv pall-30">
			<!-- 表格 -->
			<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
				@row-click="headerRowClick" v-loading="tabLoading" :row-style="{ cursor: 'pointer' }">
				<template v-slot:img="scope">
					<img :src="scope.row.imgUrl" alt="" class="tableImg" v-if="scope.row.imgUrl">
				</template>
			</EleTable>
			<!-- 分页 -->
			<PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" />
		</TableHeightFull>
		<!-- 新增父级弹框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" top="20vh" width="30%" @close="resetForm">
			<div class="banner flex flex-ja">
				<el-radio v-model="radioLabel" label="1" :disabled="able" border>展示banner图</el-radio>
				<el-radio v-model="radioLabel" label="2" :disabled="disabled" border>不展示banner图</el-radio>
			</div>
			<template v-if="radioLabel=='1'">
				<el-form :model="ruleParent" ref="ruleParent" label-width="100px" class="demo-ruleForm">
					<el-form-item label="图片" prop="imgUrl" v-if="'imgUrl' in ruleParent"
						:rules="{required: true, message: '图片不能为空', trigger: 'blur'}">
						<upload-file upStyle="width: 80px; height: 80px; border-radius: 5px; overflow: hidden;"
							iconName="el-icon-upload" iconSize="26" v-model="ruleParent.imgUrl"></upload-file>
					</el-form-item>
					<el-form-item label="	排序" prop="sort" v-if="'sort' in ruleParent">
						<el-input type="number" v-model="ruleParent.sort"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template v-if="radioLabel=='2'">
				<el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="轮播图名称" prop="slideName" v-if="'slideName' in ruleForm"
						:rules="{required: true, message: '商品名称不能为空', trigger: 'blur'}">
						<el-input type="text" v-model="ruleForm.slideName"></el-input>
					</el-form-item>
					<el-form-item label="系列类型" v-if="'boxType' in ruleForm" prop="boxType"
						:rules="{required: true, message: '请至少选择一个系列类型', trigger: 'change'}">
						<el-select v-model="ruleForm.boxType" placeholder="请选择" @change="handleBoxChang">
							<el-option v-for="item in boxTypes" :key="item.value" :label="item.key" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="系列名称" prop="seriesId"
						:rules="{required: true, message: '请至少选择一个商品系列', trigger: 'change'}">
						<el-select v-model="ruleForm.seriesId" filterable placeholder="请选择" @change="handleSeriesChang">
							<el-option v-for="item in seriesList" :key="item.id" :label="item.seriesName" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="图片" prop="imgUrl" v-if="'imgUrl' in ruleForm"
						:rules="{required: true, message: '图片不能为空', trigger: 'blur'}">
						<upload-file upStyle="width: 80px; height: 80px; border-radius: 5px; overflow: hidden;"
							iconName="el-icon-upload" iconSize="26" v-model="ruleForm.imgUrl"></upload-file>
					</el-form-item>
					<el-form-item label="	排序" prop="sort" v-if="'sort' in ruleForm">
						<el-input type="number" v-model="ruleForm.sort"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="affirmPopup" :loading="butLoading">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 新增子级弹框 -->
		<slider-show ref="slider-show" @refresh="getTableData"></slider-show>
	</div>
</template>
<script>
	import indexMixin from "@/utils/indexMixin"
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'draws',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
			"CountDown": (resolve) => require(["@/components/CountDown"], resolve),
			"UploadFile": (resolve) => require(["@/components/UploadFile"], resolve),
			"slider-show": (resolve) => require(["@/views/modules/goods/sliderShowDetail"], resolve),
		},
		computed: {
			...mapState('menu', {
				'boxTypes': state => state.dictList ? state.dictList.box_type : [],
			})
		},
		data() {
			return {
				retrieveForm: {
					searchValue: '',
					slideName: '',
					seriesName: '',
					boxType: ''
				},
				butLoading: false,
				tabLoading: false,
				able:false,
				disabled:false,
				radioLabel: '1',
				columns: [{
					type: 'index',
					label: '序号',
					width: '60',
					align: 'center',
					index: this.indexMethod
				}, {
					columnType: 'custom',
					label: '轮播图',
					prop: 'img',
					align: 'left',
					width: '100'
				}, {
					label: '系列名称',
					prop: 'slideName',
					width: '300',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					columnType: 'fun',
					label: '商品类型',
					prop: 'boxType',
					width: '300',
					align: 'left',
					'show-overflow-tooltip': true,
					formatData: (e) => {
						let ele = this.boxTypes.find(ele => ele.value == e)
						return ele ? ele.key : e
					}
				}, {
					columnType: 'fun',
					label: '系列名称',
					prop: 'seriesName',
					width: '300',
					align: 'left',
					'show-overflow-tooltip': true,
					// formatData: (e) => {
					// 	let ele = this.seriesList.find(ele => ele.value == e)
					// 	return ele ? ele.key : e
					// }
				}, {
					label: '排序',
					prop: 'sort',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					columnType: 'button',
					label: '操作',
					align: 'right',
					fixed: 'right',
					width: '250',
					buttons: [{
						type: 'text',
						text: '查看轮播',
						fn: this.addListChildren,
						hidden: (e) => {
							return e.seriesName == null
						}
					}, {
						type: 'text',
						text: '编辑',
						fn: this.editList,
					}, {
						type: 'text',
						text: '删除',
						fn: this.deleteList,
					}],
				}, ],
				tableData: [],
				//弹框
				dialogFormVisible: false,
				dialogTitle: '新增',
				dialogTitle2: '新增轮播',
				ruleParent: {
					imgUrl: '', //图片地址
					sort: '', //排序
				},
				ruleForm: {
					slideName: '', //轮播图名称
					boxType: 3, //盒子类型
					seriesName: '', //系列名称
					seriesId: '', //系列Id
					imgUrl: '', //图片地址
					sort: '', //排序
					id: '', //用户Id
				},
				seriesList: [], //商品系列列表
			}
		},
		mounted() {
			this.getTableData()
		},
		methods: {
			//查询
			submitSearch() {
				this.pageInfo.pageNum = 1
				this.getTableData()
			},
			//导出
			exportExcel() {},
			//获取表格数据
			getTableData() {
				this.tabLoading = true
				this.$http.get('/slideShow/findSlideShow', {
					params: {
						currentPage: this.pageInfo.pageNum,
						pageSize: this.pageInfo.pageSize,
						slideName: this.retrieveForm.slideName,
						seriesName: this.retrieveForm.seriesName,
						boxType: this.retrieveForm.boxType
					}
				}).then(({
					data: result
				}) => {
					this.tabLoading = false
					this.tableData = result.data.list
					this.pageInfo.total = result.data.total
				})
			},
			//获取商品系列列表
			handleBoxChang(even) {
				if (even == 3) {
					this.$http.get('/boxSeries/findBoxSeriesAll').then((result) => {
						this.seriesList = result.data.data
					})
				} else if (even == 5) {
					this.$http.get('/goodSeries/finGoodSeriesAll').then((result) => {
						this.seriesList = result.data.data
					})
				}
			},
			//选择系列
			handleSeriesChang(even) {
				console.log(even)
				this.ruleForm.seriesName = this.seriesList.filter(ele => ele.id == even)[0].seriesName
			},
			//新增父级列表
			addList() {
				this.dialogTitle = '新增父级'
				this.disabled = false
				this.able = false
				this.dialogFormVisible = true
				this.ruleForm= {
					slideName: '', //轮播图名称
					boxType: 3, //盒子类型
					seriesName: '', //系列名称
					seriesId: '', //系列Id
					imgUrl: '', //图片地址
					sort: '', //排序
					id: '', //用户Id
				},
				this.ruleParent={
					imgUrl: '', //图片地址
					sort: '', //排序
				}
				// this.ruleParent.sort = this.tableData.length > 0 ? this.tableData[0].sort + 1 : 1 
				this.ruleParent.sort = this.tableData.length > 0 ? this.tableData[0].sort + 1 : 1
				this.handleBoxChang(3)
			},
			//新增子级列表
			addListChildren(row) {
				this.$refs['slider-show'].init(row.id)
			},
			//编辑子级列表
			// editListChildren(row){
			// 	this.$refs['slider-show'].init(row.id)
			// },
			//取消弹窗
			handleClose(){
				this.resetForm()
				this.dialogFormVisible = false
			},
			//编辑父级列表
			editList(row) {
				this.dialogFormVisible = true
				if (!row.boxType) {
					this.dialogTitle = '编辑父级'
					this.radioLabel = '1'
					this.disabled = true
					this.able = false
					this.ruleParent = JSON.parse(JSON.stringify(row)) //排序
				} else {
					this.dialogTitle = '编辑'
					this.radioLabel = '2'
					this.disabled = false
					this.able = true
					this.ruleForm = JSON.parse(JSON.stringify(row)) //排序
				}
				this.handleBoxChang(3)
			},
			//删除
			deleteList(row) {
				this.$confirm('您确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/slideShow/removeSlideShowById', {
						id: row.id
					}).then(({
						data: result
					}) => {
						this.getTableData()
						this.$message({
							message: '删除成功',
							type: 'success'
						})
					})
				}).catch(_ => {})
			},
			//确认弹框
			affirmPopup() {
				let refName = ''
				let ruleData = ''
				if (this.radioLabel == 1) {
					refName = 'ruleParent'
					ruleData = this.ruleParent
				} else {
					refName = 'ruleForm'
					ruleData = this.ruleForm
				}
				this.$refs[refName].validate((valid) => {
					if (valid) {
						this.butLoading = true
						let apiUrl = ''
						if (this.dialogTitle == '新增父级') {
							apiUrl = '/slideShow/addSlideShow'
						} else if (this.dialogTitle == '编辑父级') {
							apiUrl = '/slideShow/editSlideShow'
						}else if (this.dialogTitle == '编辑') {
							apiUrl = '/slideShow/editSlideShow'
						}
						this.$http.post(apiUrl, ruleData).then((result) => {
							this.dialogFormVisible = false
							this.getTableData()
							this.resetForm()
							this.$message({
								message: this.dialogTitle + '成功',
								type: 'success'
							})
							this.butLoading = false
						}).catch(err => {
							this.butLoading = false
						})
					}
				})
			},
			//重置清除校验
			resetForm() {
				if (this.radioLabel == 1) {
					Object.assign(this.ruleParent, this.$options.data().ruleParent)
					this.$nextTick(() => {
						this.$refs.ruleParent.clearValidate()
						this.$refs.ruleParent.resetFields()
					})
				} else {
					Object.assign(this.ruleForm, this.$options.data().ruleForm)
					this.$nextTick(() => {
						this.$refs.ruleForm.clearValidate()
						this.$refs.ruleForm.resetFields()
					})
				}
			},
			// resetChilden(){
			// 	Object.assign(this.ruleForm, this.$options.data().ruleForm)
			// 	this.$nextTick(() => {
			// 		this.$refs.ruleForm.clearValidate()
			// 	})
			// },
			//表格跳转详情
			headerRowClick(row) {
				console.log(row)
			},
		},
	}
</script>
<style lang="less" scoped>
	.banner {
		margin-bottom: 20px;
	}
</style>